import Fuse from "fuse.js";
import { cleanCardData } from "@/lib/games/onePiece/getCardDataLocal";

const fuseOptions = {
  // isCaseSensitive: false,
  includeScore: true,
  shouldSort: true,
  includeMatches: false,
  // findAllMatches: false,
  // minMatchCharLength: 1,
  // location: 0,
  // threshold: 0.6,
  // distance: 100,
  // useExtendedSearch: false,
  // ignoreLocation: false,
  // ignoreFieldNorm: false,
  // fieldNormWeight: 1,
  keys: [
    "displayName",
    {
      name: "number",
      weight: 5,
    },
  ],
};

function isCardId(query: string) {
  const regex = /^(OP|ST|EB|P)(\d{2})-\d{3}$/;
  return regex.test(query);
}

export function search(query: string) {
  // handle if user searches by card number e.g. OP07-073
  if (isCardId(query)) {
    return Object.values(cleanCardData()).filter((card) => {
      return card.id.includes(query);
    });
  }

  // const searchResults = fuse.search(query);
  // const characterResults = searchResults.map(obj => obj.item);
  const searchParams = parse(query);
  return customSearch(searchParams);
}

function customSearch(searchParams: SearchParams) {
  return Object.values(cleanCardData()).filter((card) => {
    // Filter based on cost, power, format, color, and type if provided
    if (
      searchParams.cost !== undefined &&
      String(card.cost) !== String(searchParams.cost)
    ) {
      return false;
    }
    if (
      searchParams.power !== undefined &&
      String(card.power) !== String(searchParams.power)
    ) {
      return false;
    }
    if (searchParams.format) {
      const cardFormat = card.number.split("-")[0];
      if (cardFormat.toLowerCase() !== searchParams.format.toLowerCase()) {
        return false;
      }
    }
    if (
      searchParams.color !== undefined &&
      card.color?.toLowerCase() !== searchParams.color
    ) {
      return false;
    }
    if (
      searchParams.type !== undefined &&
      card.type?.toLowerCase() !== searchParams.type
    ) {
      return false;
    }

    // Check if name is in name
    if (
      searchParams.name !== undefined &&
      !card.name.toLowerCase().includes(searchParams.name.toLowerCase())
    ) {
      return false;
    }

    return true;
  });
}

interface SearchParams {
  cost: number | undefined;
  name: string | undefined;
  power: number | undefined;
  format: string | undefined;
  color: string | undefined;
  type: string | undefined;
}

export function parse(query: string): SearchParams {
  if (query.toLowerCase() === "red roc") {
    return {
      name: "red roc",
      cost: undefined,
      power: undefined,
      format: undefined,
      color: undefined,
      type: undefined,
    };
  }
  let remainingQuery = query;

  // cost
  const regex = /\b(?:[0-9]|10)c\b/g;
  const match = query.match(regex);
  let cost;
  if (match && match.length > 0) {
    cost = parseInt(match[0].replace("c", ""));
    remainingQuery = remainingQuery.replaceAll(regex, "").trim();
  }

  // power
  const regexP = /\b(?:[0-9]|10|11|12)p\b/g;
  const matchP = remainingQuery.match(regexP);
  let power;
  if (matchP && matchP.length > 0) {
    power = parseInt(matchP[0].replace("p", "")) * 1000;
    remainingQuery = remainingQuery.replaceAll(regexP, "").trim();
  }

  // format like OP07
  const regexS = /\b(?:EB|OP|ST)\w+/g;
  const matchS = remainingQuery.match(regexS);
  let format;
  if (matchS && matchS.length > 0) {
    format = matchS[0];
    remainingQuery = remainingQuery.replaceAll(regexS, "").trim();
  }

  // Promos
  const regexPromo = /\b(PR|Promo)\b/gi;
  const matchPromo = remainingQuery.match(regexPromo);
  if (matchPromo && matchPromo.length > 0) {
    format = "P";
    remainingQuery = remainingQuery.replaceAll(regexPromo, "").trim();
  }

  // Color. Use U for Blue
  const colors = [
    "red",
    "green",
    "blue",
    "yellow",
    "black",
    "purple",
    "r",
    "g",
    "u",
    "y",
    "b",
    "p",
  ];
  const regexC = new RegExp(`\\b(?:${colors.join("|")})\\b`, "gi");
  const matchC = remainingQuery.match(regexC);
  let color;
  if (matchC && matchC.length > 0) {
    color = getColor(matchC[0]).toLowerCase();
    remainingQuery = remainingQuery.replaceAll(regexC, "").trim();
  }

  // type
  const types = ["character", "event", "leader", "stage"];
  const regexT = new RegExp(`\\b(?:${types.join("|")})\\b`, "gi");
  const matchT = remainingQuery.match(regexT);
  let typeValue;
  if (matchT && matchT.length > 0) {
    typeValue = matchT[0].toLowerCase();
    remainingQuery = remainingQuery.replaceAll(regexT, "").trim();
  }

  let name = remainingQuery;

  let obj = {
    cost: cost,
    name: name,
    power: power,
    format: format,
    color: color,
    type: typeValue,
  };

  return obj;
}

function getColor(color: string) {
  switch (color.toLowerCase()) {
    case "r":
      return "red";
    case "g":
      return "green";
    case "u":
      return "blue";
    case "y":
      return "yellow";
    case "b":
      return "black";
    case "p":
      return "purple";
    default:
      return color;
  }
}
